import { Injectable } from '@angular/core';
import { ApiService } from '../root-services/api.service';
import { DownloadsNotificationState } from '../models/global/downloads-notification';
import { DownloadState } from '../models/global/download-state';

import { AnalyticsService } from '../analytics/analytics.service';

// Libraries
import * as FileSaver                     from 'file-saver';

// RxJS Interfaces
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/interval';
import 'rxjs/add/operator/mergeMap';
import 'rxjs-extra/add/operator/takeWhileInclusive';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class DownloadNotificationService {
    private downloadsNotificationState: DownloadsNotificationState = {
        downloading: false,
        downloads: [],
    };
    private filenameStore = {};
    public downloadsNotificationStateBroadcast: Subject<DownloadsNotificationState>;

    constructor(private api: ApiService, private analyticsService: AnalyticsService) {
        this.downloadsNotificationStateBroadcast = new BehaviorSubject<DownloadsNotificationState>(
            this.downloadsNotificationState
        );
    }

    public registerNewDownload(startObj: any) {
        this.handleNewDownloadState({
            state: 'downloading',
            token: startObj.token,
            progress: 0
        });
        Observable.interval(3000)
            .mergeMap(() => this.api.get(startObj.progress_url))
            .map(Response => Response.json() as DownloadState)
            .takeWhileInclusive((downloadState: DownloadState) => downloadState.state !== 'complete')
            .subscribe((downloadState: DownloadState) => this.handleNewDownloadState(downloadState));
    }

    private handleNewDownloadState(downloadState: DownloadState) {
        let newDownloadsNotificationState = Object.assign({}, this.downloadsNotificationState);
        let newDownloadsArr = Object.assign([], this.downloadsNotificationState.downloads);

        // Handle downloads array
        let alreadyExistsIndex = newDownloadsArr.findIndex(download => (download.token === downloadState.token));
        if (alreadyExistsIndex === -1) {
            newDownloadsArr.unshift(downloadState);
        } else {
            newDownloadsArr[alreadyExistsIndex] = downloadState;
        }
        newDownloadsNotificationState.downloads = newDownloadsArr;

        // Handle global download state
        newDownloadsNotificationState.downloading = newDownloadsNotificationState.downloads.reduce((acc: boolean, download) => {
            acc = acc || download.state === 'downloading' || download.state === ('processing');
            return acc;
        }, false)
        this.downloadsNotificationState = newDownloadsNotificationState;
        this.downloadsNotificationStateBroadcast.next(newDownloadsNotificationState);
    }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/root-services/download-notification.service.ts